import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import '@repair/catalog/styles.css';

import './utils/i18n/i18n';
import store from './store/store';
import { App } from './components/App';

import './global.scss';

createRoot(document.getElementById('root')).render(
  <Provider store={store}>
    <App />
  </Provider>
);
